import { css } from 'styled-components';

import { colors, breakpoints } from '@crehana/ui';

export const mainMenuDarkCustomCss = css`
  .button-xs.button-inverse-white {
    border-radius: 10px;
    border: 2px solid ${colors.white};
    color: ${colors.white};
    padding: 12px 20px;
  }

  ${breakpoints.up('sm')} {
    #register_mainMenu {
      background-color: white;
      border-radius: 10px;
      border: 2px solid ${colors.white};
      color: ${colors.primaryMain};
      padding: 20px;
    }
    #login_mainMenu {
      border-color: ${colors.white};
      color: ${colors.white};
      padding: 20px;
      border-radius: 10px;
    }
  }
  ${breakpoints.up('md')} {
    #register_mainMenu {
      color: white;
      background-color: ${colors.primaryMain};
      border: 2px solid ${colors.primaryMain};
    }
    #login_mainMenu {
      border-color: ${colors.primaryMain};
      color: ${colors.primaryMain};
    }
  }
`;

export const mainMenuLightCustomCss = css`
  .button-xs.button-inverse {
    border-radius: 10px;
    border: 2px solid ${colors.primaryMain};
    color: ${colors.primaryMain};
    padding: 12px 20px;
  }

  ${breakpoints.up('sm')} {
    #register_mainMenu {
      border-radius: 10px;
      border: 2px solid ${colors.primaryMain};
      padding: 20px;
    }
    #login_mainMenu {
      padding: 20px;
      border-radius: 10px;
    }
  }
  ${breakpoints.up('md')} {
    #register_mainMenu {
      color: white;
      background-color: ${colors.primaryMain};
      border: 2px solid ${colors.primaryMain};
    }
    #login_mainMenu {
      border-color: ${colors.primaryMain};
      color: ${colors.primaryMain};
    }
  }
`;
